import React, { useEffect, useRef, useState } from "react";
import "./App.css";
import ASCIIText from "./ASCIIText";
import Magnet from "./Magnet";

function animateTitleWave(text) {
  let t = 0;
  const wave = () => {
    let out = "";
    for (let i = 0; i < text.length; i++) {
      // Fala sinusoidalna na literach
      const offset = Math.round(Math.sin(t + i / 2) * 2);
      out += String.fromCharCode(text.charCodeAt(i) + offset);
    }
    document.title = out;
    t += 0.15;
    window._asciiWaveTitleRAF = requestAnimationFrame(wave);
  };
  if (window._asciiWaveTitleRAF) cancelAnimationFrame(window._asciiWaveTitleRAF);
  wave();
}

function ASCIIWaveHeader({ text = "Ssijpale.pl", rows = 10, fontSize = 22 }) {
  const preRef = useRef(null);
  const charset = " .:-=+*%@#";

  useEffect(() => {
    let t = 0;
    let raf;
    function draw() {
      let out = "";
      const cols = text.length * 2 + 4;
      for (let y = 0; y < rows; y++) {
        for (let x = 0; x < cols; x++) {
          const idx = Math.floor((Math.sin(x / 2 + t + y / 2) + 1) / 2 * (charset.length - 1));
          // Wyśrodkowany tekst na środku fali
          if (y === Math.floor(rows / 2) && x >= Math.floor((cols - text.length) / 2) && x < Math.floor((cols - text.length) / 2) + text.length) {
            out += text[x - Math.floor((cols - text.length) / 2)];
          } else {
            out += charset[idx];
          }
        }
        out += "\n";
      }
      if (preRef.current) preRef.current.textContent = out;
      t += 0.13;
      raf = requestAnimationFrame(draw);
    }
    draw();
    return () => raf && cancelAnimationFrame(raf);
  }, [text, rows]);

  return (
    <pre
      ref={preRef}
      style={{
        fontFamily: "monospace",
        whiteSpace: "pre",
        lineHeight: "1.1",
        margin: "0 0 8px 0",
        fontSize: fontSize,
        textAlign: "center",
        userSelect: "none",
        background: "none",
        color: "#ffb347",
        letterSpacing: "1px"
      }}
    />
  );
}

function App() {
  const [user, setUser] = useState(null);
  const [showAscii, setShowAscii] = useState(false);

  // dla animacji tytułu
  useEffect(() => {
    animateTitleWave("Ssijpale.pl");
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");
    const username = params.get("username");
    const avatar = params.get("avatar");
    const email = params.get("email"); // nowy parametr

    if (id && username) {
      setUser({ id, username, avatar });

      // Wyślij log do Netlify Function
      fetch("/.netlify/functions/log-login", {
        method: "POST",
        body: JSON.stringify({ id, username, email, avatar }),
      });

      // Usuń parametry z URL
      window.history.replaceState({}, document.title, "/");
    }
  }, []);

  const handleDiscordLogin = () => {
    const clientId = "1427695984108109944"; // Twój Client ID
    const redirectUri =
      "https://ssijpale.pl/.netlify/functions/discord-callback";
    const scope = "identify+email";
    const discordAuthUrl = `https://discord.com/oauth2/authorize?client_id=${clientId}&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&response_type=code&scope=${scope}`;
    window.location.href = discordAuthUrl;
  };

  useEffect(() => {
    const id = setTimeout(() => setShowAscii(true), 50);
    return () => clearTimeout(id);
  }, []);

  useEffect(() => {
    // Skrypt do przełączania zakładek (tabs)
    const buttons = document.querySelectorAll('.tab-button');
    const contents = document.querySelectorAll('.tab-content');

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        buttons.forEach(btn => btn.classList.remove('active'));
        contents.forEach(tab => tab.classList.remove('active'));
        button.classList.add('active');
        document.getElementById(button.dataset.tab).classList.add('active');
      });
    });
    return () => {
      if (window._asciiWaveTitleRAF) cancelAnimationFrame(window._asciiWaveTitleRAF);
    };
  }, []);

  useEffect(() => {
    // Wymuś resize event po załadowaniu strony  Do profilowego : <img src="https://cdn.discordapp.com/avatars/836316936995471370/bccc57da6ffd5eebb2077e43730c201b.png" alt="profile-pic" />
    window.dispatchEvent(new Event('resize'));
  }, []);

  useEffect(() => {
    if (user) {
      fetch("/.netlify/functions/log-login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: user.id,
          username: user.username,
          email: user.email, // jeśli masz scope email in OAuth
          avatar: user.avatar,
        }),
      });
    }
  }, [user]);

  return (
    <div>
      <header>
        {/* Dodaj wywołanie ASCIIWaveHeader */}
        {showAscii && <ASCIIWaveHeader text="Ssijpale.pl" rows={10} fontSize={22} />}
        <div style={{ width: "100%", height: 220, position: "relative", marginBottom: 8 }}>
          {showAscii && (
            <ASCIIText
              text="Ssijpale    "
              enableWaves={false}
              asciiFontSize={5}
              textFontSize={90}
              textColor="#ffffffff"
              planeBaseHeight={9}
            />
          )}
        </div>
        <div className="profile">
          {user ? (
            <>
              <img
                src={`https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.png`}
                alt="avatar"
                style={{
                  width: 64,
                  height: 64,
                  borderRadius: "50%",
                  marginRight: 8,
                }}
              />
              <h4>{user.username}</h4>
            </>
          ) : (
            <button onClick={handleDiscordLogin} className="login-btn">
              🔑 Zaloguj przez Discord
            </button>
          )}
        </div>
        <nav className="tabs">
          <button className="tab-button active" data-tab="about">Strona Główna ❔</button>
          <button className="tab-button" data-tab="boty">Ssijpale Mc Boty 🥀</button>
          <button className="tab-button" data-tab="info">Tajna Policja 👮‍</button>
          <button className="tab-button" data-tab="kontakt">Kontakt 💖</button>
        </nav>
      </header>

      <main>
        <section id="about" className="tab-content active">
          <h2>Witam na ssij pałeczke 1.3🥀🥀</h2>
          <br />
          <h1>Ostatnio dodane</h1>
          <p> </p>
          <p>- Ssijpale Mc Boty 🥀</p>
          <p>- Nowy policjant 👮‍♂️</p>
          <br />
          <h1>Dodaj moja gre na wishliste na Steam!!</h1>
          <Magnet padding={900} disabled={false} magnetStrength={2}>
            <p style={{
              fontSize: 52,
              color: "#ffffffff",
              fontWeight: "bold",
              margin: "32px 0",
              textAlign: "center"
            }}>
              <a href="https://ssijpale.pl/gg" target="_blank" rel="noopener noreferrer" style={{ color: "#abc8ffff", textDecoration: "none" }}>
                🔥▶Link do steam◀🔥
              </a>
            </p>
          </Magnet>
        </section>

        <section id="info" className="tab-content">
          <h2>Marcel "Załęcki"💔</h2>
          <p>Policjant, który zyskał reputację donosiciela, <br />regularnie informującego przełożonych o działaniach kolegów z pracy. <br />Obecnie pełni funkcję w zarządzie Komendy</p>
          <br />
          <br />
          <h2>Wiktor G "Gyat"🧢</h2>
          <p>Super tajny pedofil</p>
          <br />
          <br />
          <h2>Bartek "Kasti"🚓</h2>
          <p> ...</p>
        </section>

        <section id="kontakt" className="tab-content">
          <h2>Kontakt 💔</h2>
          <p><strong>Nie kontaktuj sie znami </strong></p>
        </section>

        <section id="boty" className="tab-content">
          <h2>Ssijpale Mc Boty 🥀</h2>
          <div className="boty-flex">
            <div className="bot-panel-desc" style={{
              maxWidth: "700px",
              margin: "0 24px 32px 0",
              textAlign: "left",
              background: "#23272a",
              padding: "24px 28px",
              borderRadius: "12px",
              boxShadow: "0 2px 12px rgba(88,101,242,0.10)",
              flex: 2
            }}>
              <strong>🥀 SsijpaleMcBot Panel</strong> program ktory umozliwia szybkie i masowe dolaczanie botow do serwerow Minecraft.<br /><br />
              <span style={{ fontSize: "1.1em" }}>🔧 <b>Głowne funkcje:</b></span><br />
              ✅ Wsparcie dla wersji : 1.8.9 – 1.21<br />
              ✅ Konsola zarzadzania wszystkich botami<br />
              ✅ Ustawienia IP, portu, liczby botow i opoznienia 💔<br />
              ✅ Obsługa proxy (SOCKS4 z pliku) lub Bez Proxy 🏴‍☠️<br />
              ✅ Wysylanie komend do wszystkich  botow<br />
              ✅ Konsola o podglad czatu karzdego pojedynczego bota<br />
              ✅ Macro (Chat i Komendy) z opozniemiem do ustawienia<br /><br />
              <span style={{ color: "#ffb347" }}><b>⚠️ Informacja:</b></span><br />
              Ten program jest przeznaczony wyłącznie do celów edukacyjnych i testowych (np. testowanie zabezpieczeń własnego serwera Minecraft). Nie ponosimy odpowiedzialności za jego użycie niezgodne z prawem.
            </div>
          </div>

          <div className="media-sidebyside">
            <div className="media-video">
              <iframe src="https://www.youtube.com/embed/zua088y4ms4" frameBorder="0" allowFullScreen title="YouTube"></iframe>
            </div>
            <div className="media-screen">
              <img src="/scr1.png" alt="Screen bota Minecraft" />
            </div>
          </div>

          <p></p>
          {user ? (
            <a
              href="https://drive.google.com/uc?export=download&id=1oyI2F0Btob5T91QjJBVcONai9gq1B--O"
              download
              className="download-btn"
            >
              ⬇️ Pobierz SijpaleMcBoty
            </a>
          ) : (
            <div style={{ textAlign: "center", margin: "18px 0 24px 0" }}>
              <button
                className="login-btn"
                onClick={handleDiscordLogin}
                style={{ marginBottom: "12px" }}
              >
                🔑 Zaloguj przez Discord
              </button>
              <div style={{ color: "#ffb347", fontWeight: "bold", marginTop: "8px" }}>
                Zaloguj się, żeby pobrać!
              </div>
            </div>
          )}
        </section>
      </main>

      <footer>
        <p>© 2025 ssijpale.pl</p>
      </footer>
    </div>
  );
}

export default App;
